import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { CONTRACTS_BASE_PATH } from '../constants/routes';

// Links of the module's pages: /{tenant}/contracts, /{tenant}/contracts/list, /{tenant}/contracts/show/5...
// Everything is under one base path, so the module can sit next to other modules in a host app.
const useContractsPaths = () => {
    const { tenant } = useParams();
    return useMemo(() => {
        const base = `/${tenant}/${CONTRACTS_BASE_PATH}`;
        return {
            base,
            dashboard: base,
            list: `${base}/list`,
            listWithStatus: (status) => `${base}/list?status=${encodeURIComponent(status)}`,
            create: `${base}/create`,
            edit: (id) => `${base}/edit/${id}`,
            show: (id) => `${base}/show/${id}`,
            settings: `${base}/settings`,
        };
    }, [tenant]);
};

export default useContractsPaths;
